module.exports = __webpack_public_path__ + "img/dosbox_icon.9bb3a867.png";